import { render, staticRenderFns } from "./customer-info.vue?vue&type=template&id=6efcd330"
import script from "./customer-info.vue?vue&type=script&lang=js"
export * from "./customer-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports